module.exports = __webpack_public_path__ + "img/wallet-ico.6065df6d.png";